import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EventEmitter } from '@angular/core';
import { Component, Output } from '@angular/core';
import { IxellAPIService, StatsDropdownValue, StatsGraphFilterKind, StatsKeyfactorKind } from 'src/app/tools/api.service';


export interface KeyFactorProps {
  name: StatsKeyfactorKind;
  visible: boolean;
}


@Component({
  selector: 'stats-kf-modal',
  templateUrl: './kf-modal.component.html',
  styleUrls: ['./kf-modal.component.scss']
})

export class StatsKFModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<KeyFactorProps[]>();

  keyfactors: KeyFactorProps[] = [];

  kfKeys: { [kf in StatsKeyfactorKind]: string } = [
    "stats.keyFactors.titles.bounceRate",
    "stats.keyFactors.titles.visits",
    "stats.keyFactors.titles.uniqueUsers",
    "stats.keyFactors.titles.sessions",
    "stats.keyFactors.titles.pagesPerSessionOnAverage",
    "stats.keyFactors.titles.avgTimePerSession",
    "stats.keyFactors.titles.mostPopularModel",
    "stats.keyFactors.titles.mostPopularColor",
  ]

  private statsGetKFOrderSub: any;

  constructor(private apiService: IxellAPIService) { }

  ngOnInit() {
    this.statsGetKFOrderSub = this.apiService.statsGetKFOrder().subscribe(data => {
      this.keyfactors = [];
      let allValues = Object.keys(StatsKeyfactorKind).filter((v) => !isNaN(Number(v))).map(e => Number(e));

      for (let kf of data) {
        this.keyfactors.push({ name: kf, visible: true });
        allValues.splice(allValues.indexOf(kf), 1);
      }

      for (let kf of allValues) {
        this.keyfactors.push({ name: kf, visible: false });
      }

      if (this.statsGetKFOrderSub != null) this.statsGetKFOrderSub.unsubscribe();
    });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.statsGetKFOrderSub != null) this.statsGetKFOrderSub.unsubscribe();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.keyfactors, event.previousIndex, event.currentIndex);
  }

  doClose() {
    this.close.emit();
  }

  doSave() {
    this.save.emit(this.keyfactors);
  }
}
